import { Link } from "gatsby";
import * as React from "react";
import * as style from "./style.module.css";
import ArticleList from "/src/components/ArticleListTop";
import BackgroundMedia from "/src/components/BackgroundMedia";
import BottomContact from "/src/components/BottomContact";
import Layout from "/src/components/Layout";
import MainButton from "/src/components/MainButton";
import Seo from "/src/components/Seo";
import FadeIn from "/src/components/FadeIn";
import Slideshow from "/src/components/Slideshow";
import YouTubeEmbed from "/src/components/Youtube/index.jsx";
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType";
import kv from "/src/images/movie/test.mp4";
import sample from "/src/images/top/sample.jpg";
import top1 from "/src/images/top/top1.jpg";
import pen from "/src/images/top/pen.png";

import t01 from "/src/images/top/t01.jpg";
import t02 from "/src/images/top/t02.jpg";

import teacher1 from "/src/images/picture/01.jpg";
import teacher2 from "/src/images/picture/02.jpg";
import teacher3 from "/src/images/picture/03.jpg";
import teacher4 from "/src/images/picture/04.jpg";
import teacher5 from "/src/images/picture/05.jpg";

import pdfImg from "/src/images/pdf/class.jpg";

import slide01 from "/src/images/top/slide01.png";
import slide02 from "/src/images/top/slide02.jpg";
import slide03 from "/src/images/top/slide03.jpg";
import slide04 from "/src/images/top/slide04.jpg";
import pdf from "/src/images/files/zyugyou.pdf";

import UnderlineComponent from "/src/components/UnderlineComponent";

const Page = ({ pageContext }) => {
  const images = [slide01, slide02, slide03, slide04];

  const Group = {
    box: [
      {
        YoutubeUrl: "JARr_CXqSv0?si=jYx0T720a5Q1pZiR",
      },
      {
        YoutubeUrl: "qJpvnXj8YUA?si=D_obNVXD3AL-SthK",
      },
      {
        YoutubeUrl: "SlNLwHtBwwo?si=FeO_0XgU2M4EVNH5",
      },
    ],
  };

  const interview = {
    title: [
      {
        img: teacher1,
        name: "ノリ先生",
        item: "",
        YoutubeUrl: "JARr_CXqSv0?si=jYx0T720a5Q1pZiR",
      },
      {
        img: teacher2,
        name: "イノ先生",
        item: "",
        YoutubeUrl: "JARr_CXqSv0?si=jYx0T720a5Q1pZiR",
      },
      // {
      //   img: teacher3,
      //   name: "Cさん 教授",
      //   item: "",
      //   YoutubeUrl: "JARr_CXqSv0?si=jYx0T720a5Q1pZiR",
      // },
      {
        img: teacher4,
        name: "こばやん先生",
        item: "",
        YoutubeUrl: "JARr_CXqSv0?si=jYx0T720a5Q1pZiR",
      },
      {
        img: teacher5,
        name: "キム先生",
        item: "",
        YoutubeUrl: "JARr_CXqSv0?si=jYx0T720a5Q1pZiR",
      },
    ]
  }

  const scheduleData = {
    "4年生": [
      { day: "火", time: "16:50～19:00", subject: "算理" },
      { day: "火", time: "16:50～19:00", subject: "理算" },
      { day: "木", time: "16:50～19:00", subject: "国社" },
      { day: "木", time: "16:50～19:00", subject: "社国" },
      { day: "金", time: "16:50～19:00", subject: "算国" },
      { day: "金", time: "16:50～19:00", subject: "国算" },
      { day: "金", time: "19:15～1時間程度", subject: "算演" },
      { day: "金", time: "19:00～19:15<br >"+"食事休憩", break: true },
    ],
    "5年生": [
      { day: "月", time: "17:00～20:20", subject: "国A" },
      { day: "月", time: "17:00～20:20", subject: "国B" },
      { day: "月", time: "18:30～18:50<br >"+"食事休憩", break: true },
      { day: "水", time: "17:00～20:20", subject: "算A" },
      { day: "水", time: "17:00～20:20", subject: "算B" },
      { day: "水", time: "18:30～18:50<br >"+"食事休憩", break: true },
      { day: "金", time: "17:00～20:20", subject: "社理" },
      { day: "金", time: "17:00～20:20", subject: "理社" },
      { day: "金", time: "18:30～18:50<br >"+"食事休憩", break: true },
      { day: "土", time: "14:30～", subject: "算演" },
    ],
    "6年生": [
      { day: "月", time: "17:10～20:30", subject: "算A" },
      { day: "月", time: "17:10～20:30", subject: "算B" },
      { day: "月", time: "18:40～19:00<br >"+"食事休憩", break: true },
      { day: "火", time: "17:10～20:30", subject: "国A" },
      { day: "火", time: "17:10～20:30", subject: "国B" },
      { day: "火", time: "18:40～19:00<br >"+"食事休憩", break: true },
      { day: "水", time: "17:10～20:30", subject: "理A" },
      { day: "水", time: "17:10～20:30", subject: "社B" },
      { day: "水", time: "18:40～19:00<br >"+"食事休憩", break: true },
      { day: "木", time: "17:10～20:30", subject: "社A" },
      { day: "木", time: "17:10～20:30", subject: "理B" },
      { day: "木", time: "18:40～19:00<br >"+"食事休憩", break: true },
      { day: "土", time: "17:00～", subject: "算演A" },
      { day: "土", time: "17:00～", subject: "算演B" },
      { day: "日", time: "10:00～" },
      { day: "日", time: "～12:30" },
      { day: "日", time: "13:00～" },
      { day: "日", time: "～12:30" },
    ]
  };

  return (
    <Layout>
      <section className={style.topSec}>
        <div className={style.top_visual_media_outer}>
          {/* Grawsの管理画面と紐づけ */}
          {/* <BackgroundMedia media={pageContext.headMedia} /> */}

          {/* local上で見れる
          kvが動画の場合
          <video autoPlay muted loop playsInline>
            <source src={kv} type={"video/mp4"}/>
          </video>

          kvが画像の場合 */}

          <Slideshow images={images} />
          {/* <img src={sample} className={style.kv}/> */}
        </div>

        <section className={style.youtubeSec}>
          <div className={style.youtubecontent}>
            <h2>Youtube人気動画</h2>
            <div className={`flex_sb ${style.youTubeBox}`}>
              {Group.box.map((A, index) => {
                return (
                  <div className={style.youtubeItem} key={index}>
                    <YouTubeEmbed videoId={A.YoutubeUrl} />
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        {/* <div className={style.top_Backwrap}>
          <div className={style.top_wrap}>
            <div className={style.photo}>
              <img src={top1} alt="Sample" className={style.sampleImage} />
            </div>
          </div>
        </div> */}
      </section>

      {/* 不要の場合削除 */}
      {/* <section className={`content ${style.slidesec}`}>
          <h2 class="heading">Slideshow</h2>
          <Slideshow images={images} />
      </section> */}

      <section className={style.blogsec}>
        <div className={style.content}>
          <div className={style.section_description}>

            <h3>お知らせ</h3>
            {pageContext.articles.length !== 0 ? (
              <>
                <div className={style.blog_items}>
                  <ArticleList articles={pageContext.articles} />
                </div>
                <div className={style.more_btn}>
                  <MainButton
                    link={getPathFromTemplateType(4)}
                    text="詳細はこちら"
                  />
                </div>
              </>
            ) : (
              <div className={style.blog_textarea_empty}>
                <p>現在、記事は投稿されていません。</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className={style.schedulesec}>
        <div className="content">
          <div className={style.textBox}>
            <h2 className={style.en}><span>S</span>chedule</h2>
            <p className={style.title}>授業日程表</p>
          </div>
          {/* <div className={style.pdfPreview}>
            <img
              src={pdfImg}
              alt="授業日程表"
            />
          </div> */}

            {/* -----------pc用の授業日程表------------ */}
          <table className={style.scheduleBoard}>
            <tbody>
              <tr>
                <th colspan="2" className={style.color}>　　　</th>
                <th colspan="3" className={style.color}>月</th>
                <th colspan="3" className={style.color}>火</th>
                <th colspan="3" className={style.color}>水</th>
                <th colspan="3" className={style.color}>木</th>
                <th colspan="3" className={style.color}>金</th>
                <th colspan="3" className={style.color}>土</th>
                <th colspan="2" className={style.color}>日</th>
              </tr>
              {/* -----------4年生------------ */}
              <tr>
                <th colspan="2" rowspan="4" className={style.color}>4年生</th>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">16:50～19:00</td>
                <td className={style.center}>算理</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">16:50～19:00</td>
                <td className={style.center}>国社</td>
                <td colspan="2">16:50～19:00</td>
                <td className={style.center}>算国</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">16:50～19:00</td>
                <td className={style.center}>理算</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">16:50～19:00</td>
                <td className={style.center}>社国</td>
                <td colspan="2">16:50～19:00</td>
                <td className={style.center}>国算</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="3" className={style.offTime}>19:00～19:15<br />食事休憩</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">19:15～1時間程度</td>
                <td className={style.center}>算演</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              {/* -----------4年生------------ */}
              {/* -----------5年生------------ */}
              <tr>
                <th colspan="2" rowspan="3" className={style.color}>5年生</th>
                <td colspan="2">17:00～20:20</td>
                <td className={style.center}>国A</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">17:00～20:20</td>
                <td className={style.center}>算A</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">17:00～20:20</td>
                <td className={style.center}>社理</td>
                <td colspan="2">14:30～</td>
                <td className={style.center}>算演</td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td colspan="2">17:00～20:20</td>
                <td className={style.center}>国B</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">17:00～20:20</td>
                <td className={style.center}>算B</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">17:00～20:20</td>
                <td className={style.center}>理社</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td colspan="3" className={style.offTime}>18:30～18:50<br />食事休憩</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="3" className={style.offTime}>18:30～18:50<br />食事休憩</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="3" className={style.offTime}>18:30～18:50<br />食事休憩</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              
              {/* -----------5年生------------ */}
              {/* -----------6年生------------ */}
              <tr>
                <th colspan="2" rowspan="4" className={style.color}>6年生</th>
                <td colspan="2">17:10～20:30</td>
                <td className={style.center}>算B</td>
                <td colspan="2">17:10～20:30</td>
                <td className={style.center}>国B</td>
                <td colspan="2">17:10～20:30</td>
                <td className={style.center}>理A</td>
                <td colspan="2">17:10～20:30</td>
                <td className={style.center}>社A</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">17:00～</td>
                <td className={style.center}>算演A</td>
                <td colspan="2">10:00～</td>
              </tr>
              <tr>
              <td colspan="2">17:10～20:30</td>
                <td className={style.center}>算A</td>
                <td colspan="2">17:10～20:30</td>
                <td className={style.center}>国A</td>
                <td colspan="2">17:10～20:30</td>
                <td className={style.center}>社B</td>
                <td colspan="2">17:10～20:30</td>
                <td className={style.center}>理B</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">17:00～</td>
                <td className={style.center}>算演B</td>
                <td colspan="2">～12:30</td>
              </tr>
              <tr>
                <td colspan="3" className={style.offTime}>18:40～19:00<br />食事休憩</td>
                <td colspan="3" className={style.offTime}>18:40～19:00<br />食事休憩</td>
                <td colspan="3" className={style.offTime}>18:40～19:00<br />食事休憩</td>
                <td colspan="3" className={style.offTime}>18:40～19:00<br />食事休憩</td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">13:00～</td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2">～12:30</td>
              </tr>
              {/* -----------6年生------------ */}
              
            </tbody>
          </table>
          {/* -----------pc用の授業日程表------------ */}


            {/* -----------sp用の授業日程表------------ */}
          <div className={style.scheduleWrapper}>
            {["4年生", "5年生", "6年生"].map((grade, i) => (
              <div key={i} className={style.gradeBlock}>
                <h2 className={style.gradeTitle}>{grade}</h2>
                <div className={style.scheduleGrid}>
                  {scheduleData[grade].map((item, idx) => (
                    <div key={idx} className={`${style.card} ${item.break ? style.offTime : ""}`}>
                      <div className={style.day}>{item.day}</div>
                      <div className={style.time} dangerouslySetInnerHTML={ {__html: item.time} }></div>
                      {item.subject && <div className={style.subject}>{item.subject}</div>}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          {/* -----------sp用の授業日程表------------ */}

          
            {/* -----------pc用の成果テスト表------------ */}
        <table className={style.scheduleBoard_test}>
            <tr>
              <th className={style.color}>成果テスト</th>
              <td>16:50～19:00</td>
              <th className={style.color}>解説無</th>
              <td>月1回 金曜実施</td>
            </tr>
            <tr>
              <th rowspan="2" className={style.color}>日曜時間割</th>
              <td>9:30～12:10</td>
              <th className={style.color}>解説授業</th>
              <td>12:30～15:30頃</td>
            </tr>
            <tr>
              <td>12:30～16:00</td>
              <th className={style.color}>解説授業</th>
              <td>16:20～18:00頃</td>
            </tr>
        </table>
        {/* -----------pc用の成果テスト表------------ */}


        {/* -----------sp用の成果テスト表------------ */}
        <div className={style.scheduleCards}>
          {/* 成果テスト */}
          <div className={style.card}>
            <div className={style.header}>成果テスト</div>
            <div className={style.row}>
              <span className={style.label}>時間</span>
              <span className={style.value}>16:50～19:00</span>
            </div>
            <div className={style.row}>
              <span className={style.label}>解説</span>
              <span className={style.value}>解説無（月1回 金曜実施）</span>
            </div>
          </div>

          {/* 日曜時間割 - 午前 */}
          <div className={style.card}>
            <div className={style.header}>日曜時間割（午前）</div>
            <div className={style.row}>
              <span className={style.label}>時間</span>
              <span className={style.value}>9:30～12:10</span>
            </div>
            <div className={style.row}>
              <span className={style.label}>解説授業</span>
              <span className={style.value}>12:30～15:30頃</span>
            </div>
          </div>

          {/* 日曜時間割 - 午後 */}
          <div className={style.card}>
            <div className={style.header}>日曜時間割（午後）</div>
            <div className={style.row}>
              <span className={style.label}>時間</span>
              <span className={style.value}>12:30～16:00</span>
            </div>
            <div className={style.row}>
              <span className={style.label}>解説授業</span>
              <span className={style.value}>16:20～18:00頃</span>
            </div>
          </div>
        </div>
        {/* -----------sp用の成果テスト表------------ */}


          {/* <div className={style.more_btn}>
            <a
              href="https://juken-act.graws-service.com/static/zyugyou-67405f5bd5feae0f77bae6c9b5216d87.pdf"
              className={`${style.container} ${style.btn} ${style.btn_border_shadow} ${style.btn_border_shadow__color2}`}
              download="授業日程表.pdf"
              target="_blank" rel="noopener noreferrer"
            >
              授業日程表
            </a>
          </div> */}
        </div>

      </section>

      {/* <section className={style.aboutSec}>
        <div className={"content"}>
          <h4 className={"headline"}>
            <UnderlineComponent>中学受験 アクトの特徴と想い</UnderlineComponent>
          </h4>
          <p className={"txt"}>
            <span>
              <b>✓「学び」</b>は礼儀から
            </span>
            <br />
            「勉強だけできる子ではなく、勉強もできる子へ」
            <br />
            　子ども、特に小学生は大人へ成長していく中で基礎となる大事な時期。
            <br />
            　だからこそ勉強だけではなく、人間としても大きく成長させたい！
            <br />
            <br />
            <br />
            <span>
              <b>✓「理解させる」</b>ことで<b>「伸ばす」</b>
            </span>
            <br />
            「その場しのぎからの脱出」
            <br />
            　丸暗記、一夜漬けなどではなく、
            <br />
            　せっかく深く考える力を養える中学受験だからこそ時間をかけてでも「理解」させたい！
            <br />
            <br />
            <br />
            <span>
              <b>✓「中高進学後にその子がもっと伸びる学校」</b>の選択
            </span>
            <br />
            「偏差値≠その子に合う学校」
            <br />
            　偏差値のみで進路指導はしたくない！
            <br />
            <br />
            <br />
            <span>
              <b>✓「塾生全員志望校合格」</b>
            </span>
            <br />
            　「言わずもがな」合格させたい！
          </p>
          <MainButton link="/about" text="詳細はこちら" />
        </div>
      </section> */}

      <div className={style.topBack_Wrap}>
        {/* <section className={style.classSec}>
          <div className={"content"}>
            <div className={`flex_sb ${style.innerWrap}`}>
              <div className={style.photoBox}>
                <figure>
                  <img src={t01} alt="画像" />
                </figure>
              </div>
              <div className={style.textBox}>
                <h3 className={"headline"}>学年別クラスについて</h3>
                <p>
                  受講料など含め各クラスにおける詳細を記載しております。
                  <br />
                  これから通いたいけど費用感が気になる、
                  <br />
                  スケジュールがきになるなどご質問があればご確認ください。
                </p>
                <MainButton link="/class" text="詳細はこちら" />
              </div>
            </div>
          </div>
        </section> */}

        <section className={style.flowSec}>
          <div className={"content"}>
            <div className={`flex_sb ${style.innerWrap}`}>
              <div className={style.textBox}>
                <h3 className={"headline"}>入塾までの流れ</h3>
                <p>入塾までの流れを記載しております。</p>
                <MainButton link="/flow" text="詳細はこちら" />
              </div>
              <div className={style.photoBox}>
                <figure>
                  <img src={t02} alt="画像" />
                </figure>
              </div>
            </div>
          </div>
        </section>


        <section className={style.interviewSec}>
          <div className="content">
            <div className={style.textBox}>
              <h2 className={style.en}><span>T</span>eacher</h2>
              <p className={style.title}>講師紹介</p>
            </div>

            <div className={style.interview}>
              {interview.title.map((title, index) => {
                return (
                  <Link to="/">
                    <div className={style.intermap} key={index}>
                      <figure>
                        <img src={title.img} alt="講師イメージ" />
                      </figure>
                      <div className={style.nameBox}>
                        <p className={style.name}>{title.name}</p>
                        <p className={style.item}>{title.item}</p>
                      </div>
                      {/* <div className={style.youtubebtn}>
                        <a className={style.youtubeinner} href={title.YoutubeUrl}>youtube</a>
                      </div> */}
                    </div>
                  </Link>
                )
              })}
            </div>
          </div>
        </section>


        <section className={style.linkSec}>
          <div className={"content"}>
            <div className={`flex_sb ${style.link_inner}`}>
              <div className={style.link_faq}>
                <Link to="/faq">よくある質問</Link>
              </div>
              <div className={style.link_recruit}>
                <Link to="/recruit/office_part/">採用情報</Link>
              </div>
            </div>
          </div>
        </section>
        {/* 
        <section className={style.youtubeSec}>
          <div className={"content"}>
            <h2>Youtube人気動画</h2>
            <div className={`flex_sb ${style.youTubeBox}`}>
              {Group.box.map((A, index) => {
                return (
                  <div className={style.youtubeItem} key={index}>
                    <YouTubeEmbed videoId={A.YoutubeUrl} />
                  </div>
                );
              })}
            </div>
          </div>
        </section> */}
        <section className={style.youtubeSec}>
          <div className={style.youtubecontent}>
            <h2>Youtube人気動画</h2>
            <div className={`flex_sb ${style.youTubeBox}`}>
              {Group.box.map((A, index) => {
                return (
                  <div className={style.youtubeItem} key={index}>
                    <YouTubeEmbed videoId={A.YoutubeUrl} />
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>

      <BottomContact />
    </Layout>
  );
};

export default Page;

export const Head = ({ pageContext }) => {
  return <Seo pageContext={pageContext} />;
};
